import React, { memo } from "react";
import cx from "classnames";

export type filterButtonsType = {
  filterName: string;
  isActive: boolean;
  handleFilterClick: (id: string) => void;
};

export const FilterButtons = memo(({ filterName, isActive, handleFilterClick }: filterButtonsType) => {
  const activeStyles = {
    "!bg-[#649745] !text-white !pr-1.5": isActive,
  };

  return (
    <button
      onClick={() => handleFilterClick(filterName)}
      className={cx(
        "flex items-center gap-1 rounded-[1.75rem] py-1 px-4 text-nowrap text-[#7D7D7D] bg-[#E7E7E7]",
        activeStyles,
      )}
    >
      {filterName}
      {isActive && (
        <span className="ml-1 border-solid border-white border-1 rounded-full w-4 h-4 flex items-center justify-center">
          ×
        </span>
      )}
    </button>
  );
});
